import { render, staticRenderFns } from "./arinvlist.vue?vue&type=template&id=5dd48d38"
import script from "./arinvlist.vue?vue&type=script&lang=js"
export * from "./arinvlist.vue?vue&type=script&lang=js"
import style0 from "./arinvlist.vue?vue&type=style&index=0&id=5dd48d38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports